export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const StoreUUID = (uuid) => {
  let isUUID = localStorage.getItem("uuid");
  if (!isUUID) {
    localStorage.setItem("uuid", uuid);
    return uuid;
  } else {
    return isUUID;
  }
};

export const ReturnScalledImg = (url, _height = 200) => {
  let height = Number(url.slice(url.indexOf("x") + 1, url.lastIndexOf(".")));
  let width = Number(url.slice(url.indexOf("_") + 1, url.lastIndexOf("x")));
  let reducedHeight = _height;
  let reducedWidth = Number((_height / height) * width).toFixed();
  let finalURL = url.slice(0, url.lastIndexOf("_") + 1) + reducedWidth + "x" + reducedHeight + url.slice(url.lastIndexOf("."));
  return finalURL;
};

export const ReturnScalledWidth = (url, _height = 200) => {
  let height = Number(url.slice(url.indexOf("x") + 1, url.lastIndexOf(".")));
  let width = Number(url.slice(url.indexOf("_") + 1, url.lastIndexOf("x")));
  let reducedWidth = ((_height / height) * width).toFixed();
  return reducedWidth;
};
